import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { dataHooks } from './constants';

export type FloatingNotificationUniDriver = ReturnType<
  typeof floatingNotificationDriverFactory
>;

export const floatingNotificationDriverFactory = (base: UniDriver) => {
  const getByDataHook = (dataHook: string) =>
    base.$(`[data-hook="${dataHook}"]`);

  const notificationButton = getByDataHook(dataHooks.button);
  const notificationTextButton = getByDataHook(dataHooks.textButton);
  const notificationCloseButton = getByDataHook(dataHooks.closeButton);
  const notificationText = getByDataHook(dataHooks.notificationText);

  return {
    ...baseUniDriverFactory(base),

    /**
     * Clicks notification button.
     */
    clickButton: async (): Promise<void> => notificationButton.click(),

    /**
     * Get the notification button's text.
     */
    getButtonLabel: async (): Promise<string> => notificationButton.text(),

    /**
     * Clicks the notification text button.
     */
    clickTextButton: async (): Promise<void> => notificationTextButton.click(),

    /**
     * Get the notification text button's text
     */
    getTextButtonLabel: async (): Promise<string> =>
      notificationTextButton.text(),

    /** Clicks the notification close button
     */
    clickCloseButton: async (): Promise<void> =>
      notificationCloseButton.click(),

    /**
     * Get the notification text.
     */
    getText: async (): Promise<string> => notificationText.text(),

    /**
     * Checks whether button with passed tag name exists.
     * @param as Tag name
     */
    isButtonAs: async (as: keyof HTMLElementTagNameMap): Promise<boolean> =>
      await base.$(`${as}[data-hook="${dataHooks.button}"]`).exists(),

    /**
     * Get the notification button href attribute's value.
     */
    getButtonHref: async (): Promise<string | null> =>
      notificationButton.attr('href'),

    /**
     * Get the notification button attribute's value by name.
     * @param attrName Attribute name
     */
    getButtonAttr: async (attrName: string): Promise<string | null> =>
      notificationButton.attr(attrName),

    /**
     * Checks whether text button with passed tag name exists.
     * @param as Tag name
     */
    isTextButtonAs: async (as: keyof HTMLElementTagNameMap): Promise<boolean> =>
      await base.$(`${as}[data-hook="${dataHooks.textButton}"]`).exists(),

    /**
     * Get the notification text button href attribute's value.
     */
    getTextButtonHref: async (): Promise<string | null> =>
      notificationTextButton.attr('href'),

    /**
     * Get the notification text button attribute's value by name.
     * @param  attrName Attribute name
     */
    getTextButtonAttr: async (attrName: string): Promise<string | null> =>
      notificationTextButton.attr(attrName),
  };
};
